var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.dashboardUrl
      ? _c("iframe", {
          staticStyle: { width: "100%", height: "calc(100vh - 56px)" },
          attrs: { frameborder: "0", src: _vm.dashboardUrl }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }